<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.orientacoes"
                    v-model="model.orientacoes"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
export default {
    computed: {
        validations() {
            return {
                orientacoes: {
                    min: 2,
                    max: 3000,
                },
            }
        },
    },
    methods: {
        validate() {

            return this.$refs.RkmForm.validate()
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    this.data.model.orientacoes = this.model.orientacoes
                    this.$emit('saved', this.model.orientacoes)
                }
            })
        },
    },
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
}
</script>